/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../../../Shared/Constants/App';
import { Icons } from '../../../../../Shared/Constants/Icons';
import {
  CongratsText,
  CongratsContainer,
  SuccessWrapper,
  CloseIconStyle,
  buttonStyle,
} from '../../../../Vendor/Components/CreateBid.Style';

interface BidApprovalProps {
  open: boolean;
  onClose: () => void;
  headerImg: any;
  message: string;
  isFromEmail: boolean;
}

const BidApprovalPopup: React.FC<BidApprovalProps> = ({ open, onClose, headerImg, message, isFromEmail }) => {
  const { t } = useTranslation(['altTexts']);
  const { button, buttonTextStyle } = buttonStyle;
  const navigate = useNavigate();
  const navigateToPendingCustomerApproval = () => {
    navigate(Paths.PendingCustomerApprovalOneTimeJobs);
  };
  return (
    <SuccessWrapper open={open} onClose={onClose}>
      <CloseIconStyle onClick={onClose}>
        <img src={Icons.InfoWindowCloseIcon} alt={t('altTexts:closeIcon')} />
      </CloseIconStyle>
      <CongratsContainer sx={{ borderRadius: '1.5rem' }}>
        <Box sx={{ margin: '3rem 0 2.5rem 0' }}>
          <img src={headerImg} />
        </Box>
        <CongratsText sx={{ marginLeft: '1rem', marginRight: '1rem', textAlign: 'center' }}>{message}</CongratsText>
        {!isFromEmail ? (
          <Box sx={{ mb: 5 }}>
            <Button sx={{ ...button }} onClick={() => navigateToPendingCustomerApproval()} disabled={false}>
              <Typography sx={{ ...buttonTextStyle, textTransform: 'none' }}>
                {t('homePage:goBackToPendingCustomerApprovalJobs')}
              </Typography>
            </Button>
          </Box>
        ) : null}
      </CongratsContainer>
    </SuccessWrapper>
  );
};

export default BidApprovalPopup;
